module.exports = __webpack_public_path__ + "img/ИФ-1(А)-043-m.f271fb8c.png";